<template>
    <at-ta
      :members="textAreaMembers"
      :allow-spaces="false"
      :ats="['$(']"
      :filter-match="filterMatch"
      name-key="name"
      @insert="handleAt">
        <!--        <div class="your-editor" contenteditable></div>-->
        <v-textarea v-model="content"
                    :error="!content"
                    :rules="validationRules"
                    :counter = "counter"
                    outline
                    :no-resize="type==='textfield'"
                    :class="type==='textfield'?'textfieldClone': ''" @input="updateValue()">
                    <slot />
        </v-textarea>
        <!--
         :error="!content"
                     :error-messages="!content? validationMsg:''"
         -->

    </at-ta>
</template>


<script>
    import AtTa from 'vue-at/dist/vue-at-textarea'
    import {mapGetters} from "vuex";
    import VueTribute from 'vue-tribute'

    export default {
        components: {AtTa, VueTribute},
        // props: {
        //     data: {
        //         type: Object,
        //         default: () => {
        //             return {}
        //         }
        //     },
        //     type: {
        //         type: String,
        //         default: () => {
        //             return 'textarea'
        //         }
        //     },
        //     validation: {
        //         type: Object,
        //         default: () => {
        //             return {}
        //         }
        //     }
        // },

        props: ['value', 'type', 'validationRules', 'counter', 'members'],
        data() {
            return {
                content: this.value
            }
        },
        computed: {
            textAreaMembers() {
                if(!this.members && !this.globalAttributes) return []
                return this.$_.uniq(this.members && Array.isArray(this.members) ? this.members : this.globalAttributes)
            },
            globalAttributes() {
                let variables = this.$store.state.blocksBuild.variables;
                return variables.map(a => ({ name: a.variable })).filter(x => x.name);
                // return variables
            }
        },
        created() {
            // console.log(this.value, ' autocom vmodel')
        },
        methods: {  
            updateValue() {
                this.$emit('input', this.content);
            },
            handleAt(name) {
                this.content = this.content.replace(/\s?$/, '') + ')';
                this.$emit('input', this.content);

            },
            filterMatch(name, chunk, at){
                // console.log('name', name, 'chunk', chunk)
                // match at lower-case
                return name.toLowerCase()
                  .indexOf(chunk.toLowerCase()) > -1 || name.toLowerCase().includes(chunk.toLowerCase())
                // return true
            }
        },
        watch: {
            value(val) {
                // console.log(val, ' this.value')
                this.content = val
            },

        }
    }
</script>
